import React from "react";
import { useTranslation } from "react-i18next";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

export default function LateCheckbox(props) {
    const { t } = useTranslation("translation");

    return (
        <FormGroup>
            <FormControlLabel
                control={<Checkbox checked={props.late}   onChange={(event, newValue) => {
                    props.HandleLate(newValue);
                }} />}
                label={t("Late")}
            />
        </FormGroup>
    );
}
